

import Vue from 'vue'
import App from './App'
import router from './router'
import 'vant/lib/index.css'
import HeyUi from 'heyui'
import i18n from './lang/lang'
import store from './store'
import Vant from 'vant';
Vue.use(HeyUi)
require("heyui/themes/index.css")
import axios from 'axios'
Vue.prototype.$ajax = axios;
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

Vue.use(ConfirmPlugin);
Vue.use(AlertPlugin);
Vue.use(Vant);
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import * as  Web3 from './components/web3.min.js'
Vue.prototype.Web3 = Web3
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
el: '#app',
router,

store,
components: { App },
i18n,
template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js